module.exports = __webpack_public_path__ + "img/detBannerOrange.76d06193.jpg";